// ─────────────────────────────────────────────
//  RelieverPicker — choose who covers a break (D-05a)
//  Candidates arrive already filtered (not being relieved, not departed).
//  Pure selection UI: confirm hands the chosen reliever back to the panel,
//  which owns the state-machine call and the Firestore writes.
// ─────────────────────────────────────────────
import React, { useState } from "react";
import tokens from "../theme/tokens";
import Modal from "./Modal";
import Button from "./Button";

const { color, font, radius } = tokens;

const roleLabel = (person) =>
  person.role === "anesthesiologist"
    ? "Doctor"
    : (person.subRole || "CRNA").toUpperCase();

export default function RelieverPicker({
  channel,
  providerName,
  candidates = [],
  onConfirm,
  onCancel,
}) {
  const [selectedId, setSelectedId] = useState("");
  const selected = candidates.find((c) => c.id === selectedId) || null;

  const title = `Give ${channel ? channel[0].toUpperCase() + channel.slice(1) : ""} Break — ${providerName || ""}`;

  return (
    <Modal
      isOpen
      onClose={onCancel}
      title={title}
      maxWidth={400}
      footer={
        <>
          <Button variant="secondary" onClick={onCancel}>Cancel</Button>
          <Button disabled={!selected} onClick={() => selected && onConfirm(selected)}>
            Give Break
          </Button>
        </>
      }
    >
      {candidates.length === 0 ? (
        <>
          <p style={st.emptyHeading}>No available relievers.</p>
          <p style={st.emptyBody}>All staff are currently on break or not yet added.</p>
        </>
      ) : (
        <>
          <label htmlFor="reliever-select" style={st.label}>Reliever</label>
          <select
            id="reliever-select"
            value={selectedId}
            onChange={(e) => setSelectedId(e.target.value)}
            style={st.select}
          >
            <option value="">Pick a reliever…</option>
            {candidates.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name} · {roleLabel(c)}
              </option>
            ))}
          </select>
        </>
      )}
    </Modal>
  );
}

const st = {
  label: {
    display: "block",
    fontSize: font.size.label,
    fontWeight: font.weight.bold,
    color: color.text.secondary,
    marginBottom: 4,
  },
  select: {
    width: "100%",
    background: color.surface.card,
    border: `1px solid ${color.border.default}`,
    color: color.text.primary,
    borderRadius: radius.sm,
    padding: "10px 12px",
    fontSize: font.size.body,
    fontFamily: font.family,
    boxSizing: "border-box",
  },
  emptyHeading: {
    margin: 0,
    fontSize: font.size.body,
    fontWeight: font.weight.bold,
    color: color.text.primary,
  },
  emptyBody: {
    margin: "4px 0 0",
    fontSize: font.size.body,
    color: color.text.muted,
  },
};
